import { BaseApiPromise } from '@lumapps/base-api';
import { ServerListRequest, ServerListResponse } from '@lumapps/base-api/types';
import { Event } from '@lumapps/events/types';

/** Generic type for a fetching API call to be used with the EventPicker  */
export type EventFetchAPI<P extends ServerListRequest> = (params: P) => BaseApiPromise<ServerListResponse<Event>>;

export type SortField = { label: string; id: string };

export enum EVENT_PICKER_FILTER_TYPES {
    TEMPORALITY_PAST = 'temporality_past',
    TEMPORALITY_ALL = 'temporality_all',
    TEMPORALITY_ONGOING = 'temporality_ongoing',
    TEMPORALITY_FUTURE = 'temporality_future',
    COMMUNITIES = 'communitiesIds',
}

export type EventPickerFilter = { id: EVENT_PICKER_FILTER_TYPES; value: string[] };

export type RequestParams = {
    filters: EventPickerFilter[];
    searchValue: string;
    sortField: SortField;
    siteIds?: string[];
};
